<template>
  <div class="idleAsset">
    <el-container style="height: 100%;min-height:100vh;" direction="vertical">
      <el-header >
        <span style="font-size: 24px;">社区闲置资源解决方案</span>
      </el-header>
      <el-main>
        <el-row>
          <span style="font-size: 20px;">1.应用场景</span>
          <p>社区闲置资源主要针对城乡社区居民闲置资源提供一个共享服务平台，在平台上进行各项闲置资源交易。如下图所示</p>
        </el-row>
        <el-row>
          <img width="600px" height="300px" src="@/assets/image/idle_assets_1.png">
        </el-row>
        <el-row>
          <span style="font-size: 20px;">2.业务功能</span>
          <center>
            <el-table  :data="envData" ref="multipleTable" border stripe="true">
              <el-table-column type="index" label="序号" width="100"></el-table-column>
              <el-table-column prop="module" label="业务模块" width="200"></el-table-column>
              <el-table-column prop="desc" label="功能描述"></el-table-column>
            </el-table>
          </center>
        </el-row>
        <el-row>
          <span style="font-size: 20px;">3.解决问题</span>
          <center>
            <el-table  :data="envProblem" ref="multipleTable" border stripe="true">
              <el-table-column type="index" label="序号" width="100"></el-table-column>
              <el-table-column prop="desc" label="问题描述"></el-table-column>
            </el-table>
          </center>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      envData: [{
        id: '1',
        module: '用户管理',
        desc: '平台提供用户（闲置资源供给用户、需求用户、现象服务用户、第三方监管用户、线上运维用户等）注册、实名认证（身份证）、授权'
      }, {
        id: '2',
        module: '资源发布',
        desc: '闲置资源供给用户根据自己的资源状况发布闲置资源，并跟踪自己发布资源的状态（发布、审核、交易、付款、用毕返还等）'
      }, {
        id: '3',
        module: '资源审核',
        desc: '闲置资源审核员进行资源审核，包括完整性、可用性、交易价格、交易条款、返还条款等'
      }, {
        id: '4',
        module: '资源监督',
        desc: '闲置资源接收政府及社区人员进行监督，防止非法资源损害社区居民利益'
      }, {
        id: '5',
        module: '资源求购',
        desc: '闲置资源需求者通过平台或微信小程序并根据自己需求选购闲置资源，选购现在资源要有会员身份，并遵从交易条款和用毕返换条款。交易金额通过C币或第三方支付平台支付'
      }, {
        id: '6',
        module: '服务推广',
        desc: '支持闲置资源向第三方交易平台进行服务推广（包括线上和线下）'
      }],
      envProblem: [{
        id: '1',
        desc: '逐步改变社区资源共享意愿，意识到闲置资源存在的价值。'
      }, {
        id: '2',
        desc: '解决社区服务机构的服务水平及建立社区与运营方，社区与社区人员的紧密关系。'
      }, {
        id: '3',
        desc: '实现多方合作，多方收益，减少社会闲置资源的浪费。'
      }, {
        id: '4',
        desc: '提升闲置资源的安全监督，及时进行事前、事中和事后处理，降低运营风险'
      }, {
        id: '5',
        desc: '有效采集社区需求心声，满足用户不同的需求。'
      }]
    }
  }
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.idleAsset {
  margin: 0px;
  padding: 0px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
}
.el-table {
  margin-left: 50px;
  margin-right: 50px;
  width: 800px;
}
</style>
